import Vue from 'vue'
import ApiService from '@/services/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    notifymeState: false,
    notifications: []
  },
  getters: {
    isLoading: state => state.isLoading,
    getNotifymeState: state => state.notifymeState,
    get: state => state.notifications || []
  },
  mutations: {
    isLoading(state, payload) {
      state.isLoading = payload === true
    },
    setNotifymeState(state, payload) {
      state.notifymeState = payload.mailNotifications === true
    },
    set(state, payload) {
      state.notifications = [].concat(payload)
    },
    setNotification(state, payload) {
      let existingIndex = state.notifications.findIndex(
        notification =>
          notification.fair === payload.fair &&
          notification.booth === payload.booth
      )
      let notificationIndex =
        existingIndex >= 0 ? existingIndex : state.notifications.length

      Vue.set(state.notifications, notificationIndex, payload)
    }
  },
  actions: {
    get(context) {
      let userId = (context.rootGetters['oidcUser'] || {}).sub

      context.commit('isLoading', { notifications: true })

      return new Promise(resolve => {
        let notifymeStateLoading = false
        let notificationsLoading = false

        ApiService.getMailNotifications(userId).then(response => {
          context.commit('setNotifymeState', response.data)
          notifymeStateLoading = true
          resolvePromise()
        })

        ApiService.getNotifications().then(response => {
          context.commit('set', response.data)
          notificationsLoading = true
          resolvePromise()
        })

        function resolvePromise() {
          if (notifymeStateLoading && notificationsLoading) {
            context.commit('isLoading', false)
            resolve(context.getters.get)
          }
        }
      })
    },
    setNotifymeState(context, state) {
      let userId = (context.rootGetters['oidcUser'] || {}).sub

      return new Promise(resolve => {
        ApiService.setMailNotifications(userId, state).then(response => {
          context.commit('setNotifymeState', response.data)
          resolve(context.getters.getNotifymeState)
        })
      })
    }
  }
}
